import React from "react";
import { Router, Route, browserHistory } from "react-router";
import Layout from "./layout/Layout";
import NoNavLayout from "./layout/NoNavLayout";
import DashboardPage from "./dashboard/DashboardPage";
import LogSourcesPage from "./log-sources/LogSourcesPage";
import IncidentsPage from "./incidents/IncidentsPage";
import ReportsPage from "./reports/ReportsPage";
import SupportPage from "./support/SupportPage";
import Callback from "./oidc/CallbackPage";
import EnsureLoggedIn from "./oidc/EnsureLoggedIn";
import SignOutCallback from "./oidc/SignOutPage";
import ErrorPage from "./error/GeneralErrorPage";
import Authorization from './authorization/authorization'
import * as roles from './authorization/roles';
export default (
  <Router history={browserHistory}>
    <Route
      path={`${global.applicationPath}/signin-oidc`}
      components={Callback}
    />
    <Route component={NoNavLayout}>
      <Route
        path={`${global.applicationPath}/signout-oidc`}
        components={{ body: SignOutCallback }}
      />
      <Route
        path={`${global.applicationPath}/error`}
        components={{ body: ErrorPage }}
      />
    </Route>
    <Route components={EnsureLoggedIn}>
      <Route component={Layout}>
        <Route
          path={`${global.applicationPath}`}
          components={{ body: Authorization(DashboardPage, [roles.CUSTOMERADMIN, roles.DASHBOARDADMIN], "incidents")}}
        />
        <Route
          path={`${global.applicationPath}/`}
          components={{ body: Authorization(DashboardPage, [roles.CUSTOMERADMIN, roles.DASHBOARDADMIN], "incidents")}}
        />
        <Route
          path={`${global.applicationPath}/log-sources`}
          components={{ body: LogSourcesPage }}
        />

        <Route
          path={`${global.applicationPath}/incidents`}
                    components={{ body: IncidentsPage }}>
                    <Route
                        path={":id/:status"}
                        components={{ body: IncidentsPage }}
                    />
        </Route>

        <Route
          path={`${global.applicationPath}/reports`}
          components={{ body: Authorization(ReportsPage, [roles.CUSTOMERADMIN, roles.REPORTADMIN])}}
        />
        <Route
          path={`${global.applicationPath}/support`}
          components={{ body: SupportPage }}
        />
      </Route>
    </Route>
  </Router>
);

// Enable Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/routes.js